// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".read-only-selector .info-expediente[data-v-cc88eb70]{margin-bottom:4px}.read-only-selector .v-data-table__checkbox[data-v-cc88eb70],.read-only-selector .v-input--selection-controls[data-v-cc88eb70]{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
